<template>
  <div class="adminDashboard">
    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>总览</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="HeaderButtons">
        <el-button
          v-if="$store.getters.checkPermission('report.get')"
          type="primary"
          size="small"
          @click="showExportDialog = true"
          >导出报表</el-button
        >
        <el-button
          icon="el-icon-refresh"
          size="small"
          circle
          @click="refreshAll"
        ></el-button>
      </div>
    </div>
    <div class="PageContent">
      <el-row :gutter="20">
        <el-col
          v-if="$store.getters.checkPermission('admin_matter')"
          key="admin_matter"
          :span="24"
        >
          <Auth ref="Auth" />
        </el-col>

        <el-col
          v-if="$store.getters.checkPermission('admin_message')"
          key="admin_message"
          :span="24"
        >
          <MessageList ref="MessageList" :managerList="managerList"/>
        </el-col>


        <el-col
          v-if="$store.getters.checkRole(3001)||$store.getters.checkRole(3002)"
          key="purchase_business_statistics"
          :span="24"
        >
          <PurchaseBusinessStatistics ref="PurchaseBusinessStatistics" :managerList="managerList"/>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="导出报表"
      :visible.sync="showExportDialog"
      width="900px"
      class="large-padding-dialog"
    >
      <el-row :gutter="20">
        <el-col :span="14">
          <el-date-picker
            v-model="exportDate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :clearable="false"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <!-- <el-col :span="5">
          <el-button type="primary" size="small" @click="exportOverview"
            >每日概况报表</el-button
          >
        </el-col>
        <el-col :span="5">
          <el-button type="primary" size="small" @click="exportTenantData"
            >商户数据报表</el-button
          >
        </el-col> -->
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showExportDialog = false">{{l("取 消")}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Auth from "./operation/Auth.vue";
import MessageList from "./operation/MessageList.vue";
import PurchaseBusinessStatistics from "./operation/PurchaseBusinessStatistics.vue";

export default {
  name: "AdminDashboard",
  components: {
    Auth,
    MessageList,
    PurchaseBusinessStatistics,
  },
  data() {
    return {
      timer: null,

      showExportDialog: false,
      exportDate: [
        this.$utils.formatDate(new Date()),
        this.$utils.formatDate(new Date()),
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      managerList:[]
    };
  },
  created() {
    this.startTimer();
    this.getManagerList();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    refreshAll() {
      clearTimeout(this.timer);
      this.$refs.Auth && this.$refs.Auth.GetTableList();
      this.$refs.MessageList && this.$refs.MessageList.GetTableList();
      this.startTimer();
    },
    startTimer() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.refreshAll();
      }, 180000); //3分钟自动刷新一次
    },
    getManagerList() {
      let requestRole = "3004,3005,30041,30051";
      if(this.$store.getters.checkRole(3004)||this.$store.getters.checkRole(30041)){
        requestRole = "3004,30041";
      }
      else if(this.$store.getters.checkRole(3005)||this.$store.getters.checkRole(30051)){
        requestRole = "3005,30051";
      }
      this.axios
        .get("/api/admin_user/backend_user_simple_list/", {
          params: {
            role: requestRole
          },
        })
        .then((data) => {
          this.managerList = data;
        });
    },
    // exportOverview() {
    //   this.axios.get("/api/report/export_overview/", {
    //     params: {
    //       start_date: this.exportDate[0],
    //       end_date: this.exportDate[1],
    //     },
    //   });
    // },
    // exportTenantData() {
    //   this.axios.get("/api/report/export_tenant_data/", {
    //     params: {
    //       start_date: this.exportDate[0],
    //       end_date: this.exportDate[1],
    //     },
    //   });
    // },
  },
};
</script>

<style scoped lang="scss">
.adminDashboard {
  background: #f1f1f1 !important;
  .PageContent {
    padding: 0%;
  }
}
</style>

